import { AfterViewInit, Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Field, FieldMap, QueryBuilderClassNames, QueryBuilderComponent, QueryBuilderConfig, Rule, RuleSet } from 'ngx-angular-query-builder';
import { CryptoService } from 'src/app/services/crypto.service';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PreviousStateService } from 'src/app/services/previous-state.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
@Component({
  selector: 'app-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrls: ['./advance-search.component.scss']
})
export class AdvanceSearchComponent {
  skelition: boolean = true;
  query: any = {
    condition: 'and',
    rules: []
  };
  ous: any[] = [];

  queryBuilderRules: RuleSet = {
    condition: 'AND',
    rules: []
  }
  translator: TranslatorPipe = new TranslatorPipe()
  queryBuilderStyle: QueryBuilderClassNames = {

  }

  queryBuilderConfig: QueryBuilderConfig = {
    fields: {}
  }

  comparisonOperators: any[] = [
    { value: 'contains all', label: this.translate('All these words') },

    { value: 'equal', label: this.translate('This whole word or phrase') },

    { value: 'contains any', label: this.translate('Any of these words:') },


    { value: 'not contains', label: this.translate('None of these words') }
  ];

  staticFileUrl: string = GlobalConstants.staticFilesURL;
  keyCount = Object.keys;
  tags: string[] = ['Ministries/Entities', 'Organisational Units'];
  messages: any[] = [];
  dataTypes: any[] = [];
  dataFields: any[] = [];
  extras: any = {};
  filteredFields: any[] = [];
  addedFields: Field[] = [];
  searchQueryObject: any;

  constructor(
    private dataService: DataService,
    private ouService: OrgUnitsService,
    private cryptoService: CryptoService,
    private router: Router,
    private previousStateService: PreviousStateService,
    private route: ActivatedRoute,
    private permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    Promise.all([this.fetchDataTypes(),
    this.fetchOus(),
    this.fetchDataFields()]).then(e => {
      this.restoreState();
      this.skelition = false;
    });

    this.route.queryParams.subscribe(async (params) => {
      this.searchQueryObject = params['query'];
      this.unsubmitFilter();
    });


    if (localStorage.getItem('isLoggedIn') == 'true') {
      this.isLoggedIn = true
    } 

  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  restoreState() {
    if (this.previousStateService.previousState) {
      let pState = this.previousStateService.previousState;
      if (pState.extras) {
        this.extras = { ...pState.extras };
        if (this.extras.ou) {
          this.extras.ou = this.ouService.findById(this.ous, this.extras.ou);
        }
        delete pState.extras;
      }
      this.query = pState;
    }
  }

  isLoggedIn :boolean = false

  // islogin() : boolean{
  //   let login =  JSON.parse(localStorage.getItem('isLoggedIn') || "false")

  //   if(login == "false"){
  //     return false
  //   } else {
  //     return true
  //   }
  // }



  async fetchOus() {
  this.ous = await this.permissionService.extractOUChildren('CONTENT', 'r');
  console.log(this.ous)
  this.filterTreeData(this.ous);
  }

  filterTreeData(nodes: any[]): void {
    for (let i = nodes.length - 1; i >= 0; i--) {
      const node = nodes[i];
      if (this.tags.includes(node.tag)) {
        // Node matches the filter tag, keep it
        if (node.children) {
          this.filterTreeData(node.children);
        }
      } else {
        nodes.splice(i, 1);
      }
    }
  }

  async fetchDataFields() {

    try {
      let res = await this.dataService.getData('data-fields/type/with-type');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.dataFields = res.data;
      this.filteredFields = this.dataFields;
      this.mapToFields();
      console.log(this.dataFields);
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error') },
      ];
    }
  }

  mapToFields() {
    let updatedConfig: QueryBuilderConfig = {
      fields: {}
    }
    this.filteredFields.forEach(e => {
      let field: Field = { name: e.name, type: 'string', operators: this.comparisonOperators }
      updatedConfig.fields[e.name] = field;
    });
    this.queryBuilderConfig = updatedConfig;
  }

  async fetchDataTypes() {
    try {
      let res = await this.dataService.postData('data-type/get/?offset=1000&page=1', {});
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.dataTypes = [{ arabic: this.translate('ALL'), _id: '' }, ...res.data];
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error') },
      ];
    }
  }

  async submitFilter() {
    if (this.extras.ou) {
      this.extras.ou = this.extras.ou.id;
    }
    this.query.extras = this.removeEmptyStringFields(this.extras);
    this.previousStateService.previousState = this.query;
    let encryptedQuery = this.cryptoService.encodeObject(this.query);
    let query = { query: encryptedQuery };
    this.router.navigate(['/advance-search/result'], { queryParams: query })
  }


  removeEmptyStringFields(obj: any) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && (obj[key] === "" || !obj[key])) {
        delete obj[key];
      }
    }
    return obj;
  }

  unsubmitFilter() {
    let body = this.cryptoService.decodeObject(this.searchQueryObject);

    if (body.extras && body.extras.ou) {
      body.extras.ou = body.extras.ou._id
      this.extras = body.extras
    } else {
      this.extras = body.extras
    }

    this.query = body;
  }

  setDropdownFilter(event: any, name: string) {
    
    if (name == 'ou') {
      if (event.node && event.node.id) {
        this.extras.ou = event.node;
      }
      return;
    } else if (name == 'type') {
      if (event.value == '') {
        this.filteredFields = this.dataFields;
        this.mapToFields();
        delete this.extras[name];
        return;
      }
      this.filteredFields = this.dataFields.filter(d => d['data-type'].includes(event.value));
      this.query.rules = [];
      this.mapToFields();
    }
    this.extras[name] = event.value;
    console.log(event);
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  checkDisabled(): boolean {
    let result = false;

    if (this.query.rules.length > 0) {
      let present = this.query.rules.find((r: Rule) => r.value == undefined || r.value == null);
      return present ? true : false;
    }

    if (!this.query) {
      result = true;
    }

    let extras = this.extras;
    if (!extras || (!extras.likeAll && !extras.sameWord && !extras.likeAny && !extras.notContains && !extras.type && !extras.ou)) {
      result = true;
    }

    if (this.query.rules.length == 0) {

    }

    return result;
  }
}
